import BaseComponent from 'primevue/basecomponent';

var script = {
    name: 'Row',
    extends: BaseComponent,
    render() {
        return null;
    }
};

export { script as default };
